import getApi from '../../../api/apisauceConfig'
import { Team } from '../../../model/Team'
import { TeamMutationPayload } from './teams.model'

export const putTeam = (teamId: string, payload: TeamMutationPayload) =>
  getApi().put<Team>(`admin/teams/${teamId}`, payload)
